export default ['Пеша', 'Градски транспорт', 'Автомобил', 'Никакъв']
